import React, { useState, useEffect } from "react";
import ProductListingAPICall from "../../service/ProductListingAPICall";
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import liveAuth from 'src/helper/liveAuth';
import Helper from "src/helper/Helper";

const SendEmailOfCurrentPage = (props) => {
    const { SetStatus } = props;
    const [__check] = useAxiosIndicatorCheck();
    const [sendToEmail, setSendToEmail] = useState([{}])
    const [emailBody, setEmailBody] = useState({ sender: System.avUserInfoData.email })
    const [error, setErrors] = useState({})
    const [{ latest_system_notification_UUID, latest_system_notification_name }, { }, { }] = useDOMAttachToSystemStore();
    const sendMailUrl = window.location.href
    useEffect(() => {
        if (latest_system_notification_name === 'SendEmailOfCurrentPage') {
            setSendToEmail([{}])
            SetStatus(true)
        } else {
            SetStatus(false)
        }
    }, [latest_system_notification_UUID]);

    const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const handleChange = (i, e) => {
        let newSendToEmail = [...sendToEmail];
        newSendToEmail[i] = e.target.value;
        if (Object.keys(error)?.length > 0) {
            delete error['sendto' + '-' + i]
        }
        setSendToEmail(newSendToEmail);
    }

    const addFormFields = () => {
        setSendToEmail([...sendToEmail, {}])
    }

    const removeFormFields = (i) => {
        let newSendToEmail = [...sendToEmail];
        newSendToEmail.splice(i, 1);
        setSendToEmail(newSendToEmail)
    }

    const onValidateData = () => {
        let validations = {};
        Helper.valueIsNotNull(emailBody?.subject) ? (emailBody.subject?.length > 99 ? validations.subject = "Please enter a valid Subject, Max character exceeded" : '') : '';
        Helper.valueIsNotNull(emailBody?.message) ? (emailBody.message?.length > 999 ? validations.message = "Please enter a valid Message, Max character exceeded" : '') : '';
        sendToEmail.map((obj, idx) => {
            if (Helper.valueIsNotNull(obj) && !Helper.validateRegex(obj, emailPattern)) {
                validations['sendto' + '-' + idx] = "Please enter a valid Email ID";
            }
        })
        if (!Helper.valueIsNotNull(emailBody?.sender) || !Helper.validateRegex(emailBody?.sender, emailPattern)) {
            validations.sender = "Please enter a valid Email ID";
        }
        setErrors({ ...validations })
        return Object.keys(validations).length > 0 ? false : true;
    }

    const onSubmit = async (data) => {
        const valid = onValidateData()
        if (valid) {
            let reqBody = {
                "link": sendMailUrl,
                "sender": emailBody.sender,
                "sendTo": sendToEmail,
                "subject": emailBody.subject,
                "message": emailBody.message
            }
            let res = {}
            await new ProductListingAPICall().sendCurrentPageEmail(reqBody).then(function (response) {
                res = response.data;
                System.popup('ThankYouPopup', { isPDPShare: true });
            });
        }
    }

    const onHandleChange = (name, value) => {
        if (Object.keys(error)?.length > 0) {
            delete error[name]
        }
        setEmailBody({ ...emailBody, [name]: value })
    }

    return (
        <div className="avnet-modal modal-630">
            <div className="avnet-modal-inner">
                <button type="button" className="close" data-dismiss="modal"
                    onClick={() => SetStatus(false) }>×
                </button>
                <div className="modal-header justify-content-center">
                    <h2 className="pcn-modal-heading">Send a link to this page</h2>
                </div>
                <div className="modal-body">
                    <form id="hook-form">
                        <div className="summary mb-2"><strong className="block">Link</strong>
                            <div id="linkToSend">
                                {sendMailUrl}
                            </div>
                        </div>
                        <div className="row m-0">
                            <div className="col-12">
                                <div className="form-group">
                                    <label htmlFor="email">Sender <span
                                        className="mandatory">*</span></label>
                                    <input type="text" name="sender" aria-label="Share via email"
                                        id="share_input_mailFrom" size={60}
                                        className="form-control"
                                        placeholder="email@address.com"
                                        defaultValue={System.avUserInfoData.email}
                                        onChange={({ target: { value } }) => onHandleChange('sender', value)}
                                    />
                                    <p className="error">{error?.sender}</p>
                                </div>

                                {sendToEmail.map((element, index) => (
                                    <div className="form-group" key={index}>
                                        <label htmlFor="email">Send To <span
                                            className="mandatory">*</span></label>
                                        <div className="d-flex">
                                            <input type="text" name={"sendto-" + index}
                                                aria-label="Share via email"
                                                id={"share_input_mailTo-" + index} size={60}
                                                className="form-control"
                                                placeholder="email@address.com" key={index}
                                                onChange={(e) => {
                                                    handleChange(index, e)
                                                }}
                                            />
                                            {
                                                index ?
                                                    <button type="button"
                                                        className="remove-email btn-link text-black"><span
                                                            className="fa fa-times"
                                                            onClick={() => removeFormFields(index)} /><span
                                                                className="sr-only">Remove Email</span></button>
                                                    : null
                                            }
                                        </div>
                                        <p className="error">{error && error['sendto' + '-' + index]}</p>
                                    </div>
                                ))}
                                {
                                    sendToEmail?.length <= 2 ?
                                        <a className="add-more AddAnotherAddressDivOne mb-1 text-blue2 d-block"
                                            onClick={() => addFormFields()}>+ Add another address</a>
                                        : null
                                }
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label htmlFor="email">Subject</label>
                                    <input type="text" name="subject" size={60}
                                        className="form-control" id="share_input_subject"
                                        placeholder="Category" data-di-id="#share_input_subject"
                                        onChange={({ target: { value } }) => onHandleChange('subject', value)}
                                    />
                                    <p className="error">{error?.subject}</p>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label htmlFor="email">Message</label>
                                    <textarea name="message" rows={8} cols={60}
                                        className="avnet-textBox form-control h-auto"
                                        placeholder={`${liveAuth.check() ? 'I\'d like to share this page with you.' : 'Enter message (ie. I\'d like to share this page with you)'}`}
                                        id="share_input_body"
                                        onChange={({ target: { value } }) => onHandleChange('message', value)}
                                    />
                                    <p className="error">{error?.message}</p>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                {__check(['SEND_CONTACT_US_EMAIL_API_CALL']).render}
                {!__check(['SEND_CONTACT_US_EMAIL_API_CALL']).status &&
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary minw-auto"
                                data-bs-toggle="modal" data-bs-target="#myModal"
                                onClick={() => SetStatus(false) }>
                                Close
                            </button>
                            <button type="button" className="bs5 btn btn-primary minw-auto"
                                form="hook-form" data-bs-toggle="modal"
                                data-bs-target="#myModal" onClick={() => onSubmit()}>
                                Send
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default SendEmailOfCurrentPage;